import React from 'react';
import '../styles/style.css';

const SearchBar = ({ searchQuery, setSearchQuery, handleSearch }) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch(); // Trigger search on Enter key press
    }
  };

  return (
    <div className="search-bar">
      <input
        type="text"
        placeholder="Search items..."
        className="search-input"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={handleKeyDown} // Add keydown event handler
      />
      <button
        onClick={handleSearch}
        className="search-button"
      >
        Search
      </button>
    </div>
  );
};

export default SearchBar;
